import {AccordionLinkGroup} from 'shared/pretty-easy-navigation/models';
import {CorpusLink, MyCorpusLink} from '../links';
import {NavigationContext} from '../navigation.context';

export const CorpusGroup = (context: NavigationContext): AccordionLinkGroup => ({
    type: 'accordionLinkGroup',
    label: 'navigation.corpus_group',
    links: [
        CorpusLink(context),
        MyCorpusLink(context),
    ],
    icon: 'navigation-group__corpus',
});